import React, { useCallback, useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { DeleteModal, ConfirmMsg } from "../../MoreComponent";
import RecommentTextUpdate from "./RecommentTextUpdate/index";
import LikeToggleRecomment from "../../common/LikeToggleRecomment/index";
import { removeRecomment, loadDetailPost } from "redux/modules/postSlice";

import { DetailLine } from "../../common/commonStyle";
import { PostInfo, DetailContent, DetailAside } from "../DetailPostStyle";
import {
  ReCommentContainer,
  ReCommentDetailLine,
  DeleteItem,
  RecommentMoreContainer,
} from "./style";

function ReComments({ post, comment, recomment }) {
  const recommentRef = useRef(null);
  const dispatch = useDispatch();

  const [recommentMore, setRecommentMore] = useState(false); // 답글 더보기 토글
  const [recommentMoreId, setRecommentMoreId] = useState(""); // 더보기 클릭된 답글Id
  const [visible, setVisible] = useState(true);
  const [recommentModalToggle, setRecommentModalToggle] = useState(false); // 더보기-삭제누를시 나오는토글
  const [recommentDeleteMsgToggle, setRecommentDeleteMsgToggle] =
    useState(false); // 더보기-삭제됨 알림

  // 1: 일반유저, 3: 관리자
  const isLevel = window.localStorage.getItem("level");

  const myNickName = window.localStorage.getItem("nickname");
  const recommentAuthor = recomment.nickname;
  const recommentIsMe = myNickName === recommentAuthor;

  const setRecommentMorePropsFunc = () => {
    setRecommentMore(false);
  };
  const setVisiblePropsFunc = () => {
    setVisible(true);
  };

  // 더보기버튼 클릭
  const onClickRecommentsMore = useCallback((e) => {
    setRecommentMoreId(e.target.id);
    setRecommentMore((prev) => !prev);
  }, []);

  // 답글 수정 입력창
  const onClickRecommentUpdate = useCallback(() => {
    setVisible(false);
  }, []);

  // 삭제 - props전달할것들
  const query = "답글을 삭제하시겠습니까?";
  const notice = "삭제한 답글은 복구할 수 없습니다.";
  const afterConfirm = "답글이 삭제되었습니다";
  const onClickCancel = () => {
    setRecommentModalToggle(false);
  };
  // 답글삭제확인
  const onClickConfirm = () => {
    setRecommentModalToggle(false);
    setRecommentDeleteMsgToggle(true);

    const payload = {
      recommentId: recomment.recommentId,
    };
    dispatch(removeRecomment(payload));

    setTimeout(() => {
      setRecommentDeleteMsgToggle(false);
      dispatch(loadDetailPost(post.boardId));
    }, 700);
  };
  // 답글 삭제
  const onClickRecommentRemove = useCallback(() => {
    setRecommentMore(false);
    setRecommentModalToggle(true);
  }, []);

  // 좋아요관련
  const [like, setLike] = useState(recomment.likeCount);

  const likeCountFunc = (v) => {
    setLike(v);
  };

  // 답글 렌더링
  return recomment.isDeleted === "true" ? (
    <>
      <DeleteItem>
        <img src="/img/deleteIcon.svg" alt="삭제표시 아이콘" />
        {recomment.deleteByAdmin === "true" ? (
          <div>정책 위반으로 삭제된 답글입니다.</div>
        ) : (
          <div>사용자가 삭제한 답글입니다.</div>
        )}
      </DeleteItem>
      <DetailLine />
    </>
  ) : visible ? (
    <>
      <ReCommentContainer>
        <div className="recomment" ref={recommentRef}>
          <PostInfo>
            <div className="profileInfo">
              <img
                className="profileImg"
                referrerPolicy="no-referrer"
                src={recomment.profileImage}
                alt="account circle"
              />
              <div className="nickAndCreateAt">
                <div className="detail-nickname">{recomment.nickname}</div>
                <div className="detail-createAt">
                  {post.createdDate.substr(0, 10).replaceAll("-", ".")}
                </div>
              </div>
            </div>
            <img
              className="more"
              id={recomment.recommentId}
              src="/img/moreGray.svg"
              alt="arrow back"
              onClick={onClickRecommentsMore}
            />
          </PostInfo>

          {/* 수정,삭제 / 신고 */}
          {recommentMore &&
            parseInt(recommentMoreId) === recomment.recommentId && (
              <RecommentMoreContainer>
                {isLevel === "0" ? (
                  <div>
                    <div onClick={onClickRecommentRemove}>삭제</div>
                  </div>
                ) : recommentIsMe === true ? (
                  <div>
                    <div onClick={onClickRecommentUpdate}>수정</div>
                    <div onClick={onClickRecommentRemove}>삭제</div>
                  </div>
                ) : (
                  <div>
                    <Link
                      // 아래 url확인할것
                      to={`/boards/${post.boardId}/comments/${comment.commentId}/recomments/${recomment.recommentId}/report`}
                      state={{
                        commentId: comment.commentId,
                        recommentId: recomment.recommentId,
                      }}
                    >
                      <div>답글 신고</div>
                    </Link>
                  </div>
                )}
              </RecommentMoreContainer>
            )}

          <DetailContent>{recomment.content}</DetailContent>
          <DetailAside>
            <div className="detail-liked">
              <LikeToggleRecomment
                post={post}
                recomment={recomment}
                likeCountFunc={likeCountFunc}
              />
              <span>좋아요</span>
              <span>{like}</span>
            </div>
          </DetailAside>
        </div>
      </ReCommentContainer>

      <ReCommentDetailLine />

      {/* 삭제관련 토글 */}
      {recommentModalToggle && (
        <DeleteModal
          query={query}
          notice={notice}
          onClickCancel={onClickCancel}
          onClickConfirm={onClickConfirm}
        />
      )}
      {/* 삭제됨 알림 */}
      {recommentDeleteMsgToggle && <ConfirmMsg afterConfirm={afterConfirm} />}

      {/* </ReCommentContainer> */}
    </>
  ) : (
    <RecommentTextUpdate
      post={post}
      recomment={recomment}
      setRecommentMorePropsFunc={setRecommentMorePropsFunc}
      setVisiblePropsFunc={setVisiblePropsFunc}
    />
  );
}

export default ReComments;
